
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/playlists/[canais]",
      function () {
        return require("private-next-pages/video/playlists/[canais]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video/playlists/[canais]"])
      });
    }
  